import config from 'config';

export default function authHeader() { 
    let user = JSON.parse(localStorage.getItem('user'));
    
    return {
        'Content-Type': 'application/json',
        'X-Api-Key': `${config.apiKey}`,
        'AuthorizationToken': user.authorizationToken
    };
}


// WEBPACK FOOTER //
// ./src/_helpers/auth-header.js